import './SwitchFade.scss';
import React from 'react';
import { Switch, withRouter } from 'react-router-dom'
import { TransitionGroup, CSSTransition } from 'react-transition-group';

const SwitchFade = (props) => {

    return (
        <TransitionGroup className='transition-group'>
            <CSSTransition
                key={props.location.key}
                timeout={500}
                classNames={'fade'}
                appear
            >
                <section className='route-section'>
                    <Switch {...props} />
                </section>
            </CSSTransition>
        </TransitionGroup >
    )
}

export default withRouter(SwitchFade)